import ContactForm from '../ContactForm/ContactForm.vue'

export default {
  name: 'SiteFooter',
  components: {
    ContactForm
  },
  props: {
    isContactPage: {type: Boolean, default: false}
  },
  data: function () {
    return {
      showForms: true,
      tmgMail: 'info@tmg.io',
      tmgPhone: '201-614-4107',
      tmgAddress: {
        street: '101 Park Ave, Suite 1',
        city: ' Hoboken NJ 07030'
      },
      tmgMedia: {
        linkedin: 'https://www.linkedin.com/company/5230075'
      },
      tmgCopyright: 'Techmates Group, LLC All rights reserved.',
      year: new Date().getFullYear(),
      mailOptions: ['Start a Project', 'Work at TMG', 'Work with TMG'],
      activeOptionIdx: 0,
      userName: ''
    }
  },
  computed: {
    className: function () {
      return this.isContactPage ? 'contact-page' : ''
    }
  },
  methods: {
    onChangeUserName: function (name) {
      this.userName = name ? `, ${name}` : ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/SiteFooter/SiteFooter.js